import React from 'react';
import { canAuthorizeOrder } from '../../util/gearOrderUtil';

/**
 * Display a checkbox that allows authorizing admins to waive expedited shipping fees.
 * The admin must have access "on behalf of" the ordering or authorizing practitioner to be able to waive the fee.
 */
const WaiveShippingFeeCheckbox = ({ userInfo, gearOrder, feeWaived, setFeeWaived, style = {} }) => {
	if (userInfo?.adminUser !== 'true') {
		return null;
	}

	// Disable the checkbox if the user can't authorize this order or if the order has been submitted
	const disabledInput = !canWaiveShipping(userInfo, gearOrder) || !!gearOrder.orderFormId;

	if (disabledInput && !feeWaived) {
		return null;
	}

	return (
		<div className="checkbox-inline" style={{ ...style }}>
			<label>
				<input
					type="checkbox"
					checked={feeWaived}
					disabled={disabledInput}
					onChange={() => setFeeWaived((prevFeeWaived) => !prevFeeWaived)}
				/>
				Waive Shipping Fee
			</label>
		</div>
	);
};

/**
 * Allow waived shipping if an admin user has access "on behalf of" the ordering or authorizing practitioner.
 */
const canWaiveShipping = (userInfo, gearOrder) => {
	if (canAuthorizeOrder(userInfo, gearOrder)) {
		return true;
	}

	const onBehalfOf = userInfo.onBehalfOf?.split(',') ?? [];
	return userInfo?.adminUser === 'true' && onBehalfOf.includes(gearOrder?.practitioner?.gsdlNo);
};

export default WaiveShippingFeeCheckbox;

export const WAIVED_SHIPPING_METHOD_AFFIX = ' (Waived)';